module.exports = __webpack_public_path__ + "static/media/export.90a1460b.svg";